
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '../../node_modules/react-vis/dist/style.css';
import {
  UploadResultError, UploadResultProgress, Header, Loader, Modal, Text,
} from './common';
import { isMobileDevice, UUID } from '../helpers/Utils';
import { MAIN_HEADERS } from '../shared/constants/fieldTypes';
import StyleConstants from '../shared/constants/styleConstants/styles';
import {
  uploadStudentResults, updateAssignmentModal, getAssignmentList,
  updateTestAttribute, sendSms, showToast,
} from '../actions';
import {
  IN_PROGRESS, ERRORS, RESET, UPLOAD, VIEW_RESULT, SEND_SMS, UPDATE_STATUS,
} from '../shared/constants/textConstants';
import { ZONE_COLORS } from '../reducers/progress';
import constants from '../shared/constants/environmentConfig';

const Constants = constants();
const RESULT_UPDATE_STATUS_CHANNEL = 'ResultUpdateStatusChannel';
const styles = {
  container: {
    height: '100%',
    minHeight: '100vh',
    userSelect: 'none',
  },
  mainBlock: {
    backgroundColor: '#F8F9FC',
  },
};
const IS_MOBILE = isMobileDevice();


class TestList extends React.Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.state = {
      showLoader: false,
      searchAssignmentString: '',
      showSmsModal: 0,
      status: -1,
      showTestStatusId: '',
      cable: Object.create(null),
      subscription: Object.create(null),
      testID: 0,
    };
    this.renderListView = this.renderListView.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSmsModal = this.handleSmsModal.bind(this);
    this.uploadStudentResult = this.uploadStudentResult.bind(this);
    this.reOrderList = this.reOrderList.bind(this);
    this.renderListGroup = this.renderListGroup.bind(this);
    this.viewResult = this.viewResult.bind(this);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const actionCable = require('actioncable');
      const cable = actionCable.createConsumer(Constants.api.ws_url);
      this.setState({ cable });
      const subscription = cable.subscriptions.create({ channel: RESULT_UPDATE_STATUS_CHANNEL }, {
        received: (data) => {
          this.props.dispatch(
            updateTestAttribute(data.test_id, data.status),
          ).then(() => this.forceUpdate());
        },
      });
      this.setState({ subscription });
    }
    this.setState({ showLoader: true });
    this.props.dispatch(getAssignmentList()).then(() => {
      const { liveTestIds } = this.props;
      // this.props.dispatch(getLiveStudentCount(liveTestIds)).then(() => {
      this.setState({ showLoader: false });
      // }); 
    });
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      const { cable, subscription } = this.state;
      if (cable) {
        cable.subscriptions.remove(subscription);
      }
    }
  }

  getStudentResultFile() {
    document.getElementById('uploadStudentResultFile').click();
  }

  sendSms(smsSentId) {
    this.props.dispatch(sendSms(smsSentId)).then(() => {
      this.setState({ showLoader: false });
    });
  }

  uploadTestResult() {
    return (
      <div className="col-12">
        <div className="App-Box-Title">Upload Test Result:</div>
        <div
          className="primary-button"
          data-toggle="modal"
          data-target="#uploadResultModel"
          style={{ height: 35, width: 150, margin: 15 }}
          onClick={(e) => this.uploadResult(e)}
          role="presentation"
        >
          {UPLOAD}
        </div>
      </div>
    );
  }


  handleCloseModal() {
    this.props.dispatch(updateAssignmentModal(false));
    this.setState({ showTestStatusId: '' });
  }

  handleSmsModal(id, status) {
    if (id && status) {
      this.sendSms(id);
    }
    this.setState({ showSmsModal: status ? 0 : id });
  }

  uploadResult(event, status = '', testID = 0) {
    this.props.dispatch(updateAssignmentModal(true));
    this.setState({ testID, status });
    event.stopPropagation();
  }

  uploadStudentResult(event) {
    const { testID } = this.state;
    const fileList = event.target.files;
    const files = Object.values(fileList);
    const sendFiles = files.map((file) => {
      return new File([file], `${UUID()}.xlsx`, { type: file.type });
    });
    this.props.dispatch(uploadStudentResults(sendFiles, testID));
  }

  reOrderList(list) {
    const orderedList = {
      online: [],
      offline: [],
      live: [],
    };
    list.forEach((assignment) => {
      if (assignment.is_online && !assignment.is_published) {
        orderedList.live.push(assignment);
      } else if (assignment.is_online) {
        orderedList.online.push(assignment);
      } else {
        orderedList.offline.push(assignment);
      }
    });
    return orderedList;
  }

  viewResult(assignment) {
    const { smsStatus, testTaken, showSentSms } = this.props;
    const testTakenData = testTaken.filter((obj) => obj.id === assignment.id)[0];
    const resultAvailable = parseInt(testTakenData.test_taken_count, 10) > 0;
    const smsSent = Object.keys(smsStatus).includes((assignment.id).toString())
      ? smsStatus[assignment.id] : assignment.sms_sent;
    const alreadySent = smsSent === 1;
    const smsFailed = smsSent === 2;
    return (
      <div style={{
        display: 'flex', justifyContent: 'space-between', fontSize: 14, alignItems: 'center',
      }}
      >
        <div
          className="primary-button"
          style={{
            width: resultAvailable && showSentSms ? '45%' : '100%', cursor: !resultAvailable && 'not-allowed', opacity: !resultAvailable && '0.5',
          }}
          onClick={() => { this.renderResult(resultAvailable, assignment); }}
          role="presentation"
        >
          {VIEW_RESULT}
        </div>
        {!assignment.is_sample && resultAvailable && showSentSms && !smsFailed && (
        <div
          className="primary-button"
          style={{
            width: smsFailed ? '100%' : '45%', opacity: (alreadySent) ? '.5' : '1', cursor: (alreadySent) ? 'not-allowed' : 'pointer',
          }}
          onClick={() => (!alreadySent && this.handleSmsModal(assignment.id))}
          role="presentation"
        >
          {SEND_SMS[smsSent || 0]}
        </div>
        )}
        {smsFailed
        && (
        <div
          role="presentation"
          onClick={() => (this.handleSmsModal(assignment.id))}
          style={{ width: '45%', color: StyleConstants.color.error, cursor: 'pointer' }}
        >
          {SEND_SMS[smsSent]}
        </div>
        )}
      </div>
    );
  }

  renderResult(resultAvailable, assignment) {
    if (resultAvailable) {
      window.location.href = `/highlights/${assignment.id}`;
    } else {
      this.props.dispatch(showToast('Atleast One Student Should Have Took the Test To View Result'));
    }
  }

  renderListView(assignment) {
    const { showSmsModal } = this.state;
    const isResultPresent = (assignment.is_published);
    const pendingUpload = [
      UPDATE_STATUS.PROCESS, UPDATE_STATUS.ERROR].includes(assignment.summary.status);
    const pendingReason = assignment.summary.status === UPDATE_STATUS.ERROR ? ERRORS : IN_PROGRESS;
    const pendingColor = assignment.summary.status === UPDATE_STATUS.ERROR
      ? StyleConstants.color.error : StyleConstants.color.success;
    const { smsStatus, testTaken, showSentSms } = this.props;
    const testTakenData = testTaken.filter((obj) => obj.id === assignment.id)[0];
    const resultAvailable = testTakenData && parseInt(testTakenData.test_taken_count, 10) > 0;
    const smsSent = Object.keys(smsStatus).includes((assignment.id).toString())
      ? smsStatus[assignment.id] : assignment.sms_sent;
    const alreadySent = smsSent === 1;
    const smsFailed = smsSent === 2;

    const rowStyle = {
      display: 'flex',
      alignItems: 'center',
      padding: '14px 24px',
      backgroundColor: '#fff',
      borderBottom: '1px solid #F0F0F5',
      transition: 'background-color 0.15s ease',
      cursor: 'pointer',
    };

    const nameStyle = {
      flex: 2,
      fontWeight: '600',
      fontSize: 14,
      color: '#1a1a2e',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingRight: 16,
    };

    const metaStyle = {
      flex: 1,
      fontSize: 13,
      color: '#6B7280',
      whiteSpace: 'nowrap',
    };

    const actionStyle = {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 8,
    };

    const btnBase = {
      padding: '6px 16px',
      borderRadius: 6,
      fontSize: 12,
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.15s ease',
      letterSpacing: '0.3px',
    };

    const viewResultBtn = {
      ...btnBase,
      backgroundColor: 'transparent',
      color: resultAvailable ? '#6C5CE7' : '#9CA3AF',
      cursor: resultAvailable ? 'pointer' : 'not-allowed',
      textDecoration: resultAvailable ? 'underline' : 'none',
      padding: '6px 4px',
    };

    return (
      <div
        key={assignment.id}
        style={rowStyle}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#FAFAFF'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
      >
        <Modal showModal={showSmsModal === assignment.id} handleCloseModal={this.handleSmsModal} header="Send SMS to Parents" top="50%" width={360} height={155} headerPadding={10}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 30, gap: 10 }}>
            <div role="presentation" style={{ ...btnBase, backgroundColor: '#6C5CE7', color: '#fff' }} onClick={() => this.handleSmsModal(assignment.id, true)}>Confirm</div>
            <div role="presentation" style={{ ...btnBase, backgroundColor: '#F3F4F6', color: '#374151' }} onClick={() => this.handleSmsModal()}>Cancel</div>
          </div>
        </Modal>

        <div style={nameStyle} title={assignment.name}>
          {assignment.name}
        </div>

        <div style={metaStyle}>
          {assignment.date}
        </div>

        <div style={{ ...metaStyle, flex: 0.5, textAlign: 'center' }}>
          {assignment.question_count || 0}
          {!assignment.review && assignment.total_question_count && (
            <span style={{ color: '#D1D5DB' }}>{` / ${assignment.total_question_count}`}</span>
          )}
        </div>

        <div style={{ ...metaStyle, flex: 0.6, textAlign: 'center' }}>
          {pendingUpload ? (
            <span
              style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: '600', backgroundColor: pendingColor === StyleConstants.color.error ? '#FEF2F2' : '#F0FDF4', color: pendingColor }}
              role="presentation"
              onClick={(e) => this.uploadResult(e, assignment.summary.status, assignment.id)}
            >
              {pendingReason}
            </span>
          ) : resultAvailable ? (
            <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: '600', backgroundColor: '#F0FDF4', color: '#15803D' }}>Results Ready</span>
          ) : isResultPresent ? (
            <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: '600', backgroundColor: '#FFF7ED', color: '#C2410C' }}>No Results</span>
          ) : assignment.is_online ? (
            <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: '600', backgroundColor: '#EFF6FF', color: '#2563EB' }}>Live</span>
          ) : (
            <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: '600', backgroundColor: '#F9FAFB', color: '#9CA3AF' }}>Offline</span>
          )}
        </div>

        <div style={actionStyle}>
          {(!isResultPresent) && (!assignment.is_online) && (!pendingUpload) && (
            <div style={{ ...btnBase, backgroundColor: '#6C5CE7', color: '#fff' }} role="presentation" onClick={(event) => this.uploadResult(event, UPDATE_STATUS.UNUPLOAD, assignment.id)}>{UPLOAD}</div>
          )}
          {!isResultPresent && assignment.is_online && (
            <div style={{ ...btnBase, backgroundColor: '#EFF6FF', color: '#2563EB', border: '1px solid #BFDBFE' }} role="presentation" onClick={() => this.setState({ showTestStatusId: assignment.id })}>View Status</div>
          )}
          {!pendingUpload && isResultPresent && (
            <div style={viewResultBtn} role="presentation" onClick={() => this.renderResult(resultAvailable, assignment)}>{VIEW_RESULT}</div>
          )}
        </div>
      </div>
    );
  }

  renderStatusText(fieldName, value, background) {
    const style = {
      color: StyleConstants.color.white, margin: 0,
    };
    return (
      <div style={{
        display: 'flex', justifyContent: 'space-between', background, padding: '15px 25px', margin: '0px 40px 20px 40px', width: 360, borderRadius: 4,
      }}
      >
        <Text
          style={{ ...style }}
          text={fieldName}
        />
        <Text
          style={{ ...style }}
          text={value}
        />
      </div>
    );
  }

  renderTestStatus(assignmentId) {
    const { testTaken, liveStudentCount } = this.props;
    const showResultButton = testTaken.filter((obj) => obj.id === assignmentId)[0];
    if (showResultButton) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', fontWeight: StyleConstants.textWeight.semiBold, fontSize: StyleConstants.textSize.Header, marginTop: 20,
        }}
        >
          {this.renderStatusText('No of Students Online : ', liveStudentCount[assignmentId] || 0, ZONE_COLORS.SAFE)}
          {this.renderStatusText('Test Assigned Students Count : ', showResultButton.test_assigned_count || 0, ZONE_COLORS.REMEDY)}
          {this.renderStatusText('Test Taken Count : ', showResultButton.test_taken_count || 0, ZONE_COLORS.UPGRADE)}
        </div>
      );
    }
    return (<div />);
  }

  renderTestModal() {
    const { status, testID } = this.state;
    if (status === UPDATE_STATUS.PROCESS) {
      return (
        <UploadResultProgress id={testID} />
      );
    } if (status === UPDATE_STATUS.ERROR) {
      return (
        <UploadResultError id={testID} />
      );
    } if (testID === 0) {
      return (
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 30px' }}>
          <div>Enter Test Name</div>
          <input
            id="enterTextName"
            type="text"
            name="Test Name"
            style={{
              background: 'transparent', borderColor: 'transparent', borderBottomColor: StyleConstants.textLineColors.dark, borderRadius: 0,
            }}
          />
        </div>
      );
    }
    return (
      <div>
        <div className="d-flex flex-column justify-content-center" style={{ marginRight: global.innerWidth * 0.1, marginLeft: global.innerWidth * 0.1 }}>
          <div
            style={{ textAlign: 'center' }}
            onClick={this.getStudentResultFile}
            role="presentation"
          >
            <img alt="" src="/static/images/upload.svg" width="50px" />
            <p> Supported .xlsx </p>
            <p style={{ fontSize: '12px', color: '#cdcdce' }}>Drag or browse the Excel file to upload.</p>
          </div>
          <div style={{ height: '0px', width: '0px', overflow: 'hidden' }}>
            <input id="uploadStudentResultFile" type="file" name="result" accept=".xlsx" multiple="true" onChange={this.uploadStudentResult} />
          </div>
          <div>
            <a download="student_result.xlsx" target="_blank" href="/static/images/student_result.xlsx" style={{ width: '100%' }}>
              <div className="btn btn-outline-primary btn-block" style={{ fontSize: '14px', padding: 10 }}>
                <img alt="" src="/static/images/download.svg" style={{ width: 20, marginRight: 20, marginTop: -3 }} />
                Download
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }

  renderListGroup(list, boxStyle, clickableCard) {
    const { showTestStatusId } = this.state;

    const sectionStyle = {
      ...boxStyle,
      maxWidth: 1200,
      margin: '0 auto',
      padding: '0 24px',
      marginBottom: 32,
    };

    const headerStyle = {
      fontSize: 13,
      fontWeight: '700',
      color: '#9CA3AF',
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      padding: '12px 24px',
      borderBottom: '2px solid #F0F0F5',
      display: 'flex',
      alignItems: 'center',
    };

    const sectionTitleStyle = {
      fontSize: 18,
      fontWeight: '700',
      color: '#1a1a2e',
      marginBottom: 16,
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    };

    const countBadge = {
      fontSize: 12,
      fontWeight: '600',
      color: '#6C5CE7',
      backgroundColor: '#F0EDFF',
      padding: '2px 10px',
      borderRadius: 12,
    };

    return (
      (list.length > 0) && (
        <div style={sectionStyle}>
          <div style={sectionTitleStyle}>
            {`${clickableCard} Tests`}
            <span style={countBadge}>{list.length}</span>
          </div>
          <div style={{ backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
            <div style={headerStyle}>
              <div style={{ flex: 2 }}>Test Name</div>
              <div style={{ flex: 1 }}>Date</div>
              <div style={{ flex: 0.5, textAlign: 'center' }}>Questions</div>
              <div style={{ flex: 0.6, textAlign: 'center' }}>Status</div>
              <div style={{ flex: 1, textAlign: 'right' }}></div>
            </div>
            {list.map((assignment) => {
              return (
                <div key={assignment.id}>
                  <Modal showModal={showTestStatusId === assignment.id} handleCloseModal={this.handleCloseModal} header={assignment.name} top="25%">
                    {this.renderTestStatus(assignment.id)}
                  </Modal>
                  {this.renderListView(assignment)}
                </div>
              );
            })}
          </div>
        </div>
      )
    );
  }

  render() {
    const { testsList, showTestModal, smsBalance } = this.props;
    const { showLoader } = this.state;
    if (showLoader) {
      return <Loader />;
    }
    const { status, searchAssignmentString } = this.state;
    const list = testsList;
    const searchInProgress = (searchAssignmentString.length > 0);
    let header = 'Upload Results';
    const orderedList = this.reOrderList(list);
    let boxStyle = {};
    if (status === UPDATE_STATUS.PROCESS) {
      header = 'Processing Result';
    } else if (status === UPDATE_STATUS.ERROR) {
      header = 'Error';
    }

    if (searchInProgress) {
      boxStyle = {
        pointerEvents: 'none', opacity: '.1',
      };
    }

    return (
      <div className="row" style={styles.container}>
        <div className="col-12 col-sm-12 col-md-12" style={styles.mainBlock}>
          <Header menuData={MAIN_HEADERS[0]} smsBalance={smsBalance} showSmsBalance />
          <div className="container-fluid p-0 App-Contet">
            <div className="row no-gutter">
              <div className="container App-Test-List col-12 p-0" style={{ marginTop: 90 }}>
                <Modal showModal={showTestModal} handleCloseModal={this.handleCloseModal} header={header} top="25%">
                  {this.renderTestModal()}
                </Modal>
                {/* {!IS_MOBILE && orderedList.live.length > 0 && this.renderListGroup(orderedList.live,
                  boxStyle, 'Live')} */}
                {orderedList.online.length > 0 && this.renderListGroup(orderedList.online,
                  boxStyle, 'Online')}
                {orderedList.offline.length > 0 && this.renderListGroup(orderedList.offline, boxStyle, 'Offline')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TestList.propTypes = {
  testsList: PropTypes.array,
  smsStatus: PropTypes.object,
  showTestModal: PropTypes.bool,
  testTaken: PropTypes.array,
  showSentSms: PropTypes.bool,
  smsBalance: PropTypes.number,
  liveStudentCount: PropTypes.object,
  liveTestIds: PropTypes.array,
};

TestList.defaultProps = {
  testsList: [],
  showSentSms: false,
  smsStatus: {},
  showTestModal: false,
  testTaken: [],
  liveStudentCount: {},
  smsBalance: 0,
  liveTestIds: [],
};

const mapStateToProps = ({ dashboard, insight }) => ({
  testsList: dashboard.testsList,
  showTestModal: insight.showModal,
  smsStatus: dashboard.smsStatus,
  testTaken: dashboard.testTaken,
  showSentSms: true,
  smsBalance: dashboard.smsBalance,
  liveStudentCount: dashboard.liveStudentCount,
  liveTestIds: dashboard.liveTestIds,
});

export default connect(mapStateToProps)(TestList);
